<template>
  <div class="h-[1px] flex-1 bg-gray-200" />
</template>
